<template>
    <div>
        <b-table borderless :fields="bootstrapTable.fields" :items="data">
            <template v-slot:cell(code)="data">
                <span v-text="data.item.data.attributes.code"/>
            </template>

            <template v-slot:cell(name)="data">
                <router-link class="text-data-link" :to="data.item.links.self"
                             v-text="data.item.data.attributes.name"/>
            </template>

            <template v-slot:cell(floor)="data">
                <span v-text="data.item.data.attributes.floor"/>
            </template>

            <template v-slot:cell(facility)="data">
                <span v-text="data.item.data.attributes.facility"/>
            </template>

            <template v-slot:cell(type)="data">
                <span v-text="data.item.data.attributes.type"/>
            </template>

            <template v-slot:cell(status)="data">
                <b-badge pill style="width: 65px;"
                         :variant="data.item.data.attributes.status === 'Vacant' ? 'light' : 'info'"
                >{{ data.item.data.attributes.status }}
                </b-badge>
            </template>

            <template v-slot:cell(updated_by)="data">
                <span v-text="data.item.data.attributes.updated_by"/>
            </template>

            <template v-slot:cell(updated_at)="data">
                <span v-text="data.item.data.attributes.updated_at"/>
            </template>
        </b-table>
    </div>
</template>

<script>
    export default {
        name: "LatestUnits",
        props: ['data'],
        data() {
            return {
                bootstrapTable: {
                    fields: [
                        {key: 'code', label: 'Code', tdClass: ''},
                        {key: 'name', label: 'Name', tdClass: ''},
                        {key: 'floor', label: 'Floor', tdClass: 'text-muted'},
                        {key: 'facility', label: 'Facility', tdClass: 'text-muted'},
                        {key: 'type', label: 'Type', tdClass: 'text-muted'},
                        {key: 'status', label: 'Status', thClass: 'text-center', tdClass: 'text-center'},
                        {key: 'updated_by', label: 'Updated By', tdClass: 'text-muted'},
                        {key: 'updated_at', label: 'Updated At', tdClass: 'text-muted'},
                    ]
                }
            }
        },
    }
</script>

<style scoped>

</style>
